import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];
  static values = {
    minChecked: { type: Number, default: 1 },
    maxChecked: { type: Number, default: null },
  };

  connect() {
    // Listen for native checkbox state changes
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.updateValidity());
    });
    // Listen for custom checkbox state changes
    this.element.addEventListener("checkbox-state-changed", (event) => {
      this.updateValidity();
    });
    // Set initial validity
    this.updateValidity();
  }

  disconnect() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.removeEventListener("change", () => this.updateValidity());
    });
  }

  updateValidity() {
    const checkedBoxes = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked
    );
    const checkedCount = checkedBoxes.length;

    // Start with minimum validation as the base
    let isValid = checkedCount >= this.minCheckedValue;
    let errorMessage = "";

    // Check minimum validation
    if (checkedCount < this.minCheckedValue) {
      isValid = false;
      errorMessage = `Please select at least ${this.minCheckedValue} option${
        this.minCheckedValue === 1 ? "" : "s"
      }`;
    }

    // Check maximum validation (only if max is set)
    if (this.maxCheckedValue !== null) {
      if (checkedCount > this.maxCheckedValue) {
        isValid = false;
        errorMessage = `Please select at most ${this.maxCheckedValue} option${
          this.maxCheckedValue === 1 ? "" : "s"
        }`;
      }

      // Disable unchecked checkboxes when max is reached
      this.checkboxTargets.forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.disabled = checkedCount >= this.maxCheckedValue;
        }
      });
    }

    this.element.valid = isValid;

    // Set custom validity on all checkboxes
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.setCustomValidity(errorMessage);
    });
  }
}
